import Footer from './src/Footer.vue'

Footer.install = function(Vue) {
    Vue.component(Footer.name, Footer)
}

export default Footer